import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Button, Form, Grid, Segment, Container, Pagination } from 'semantic-ui-react';
import { Message } from 'semantic-ui-react';

import { withFirebase } from '../Firebase';
import { AuthUserContext, withAuthorization } from '../Session';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';

import axios from 'axios';

class ReportDetails extends Component {
    constructor(props) {
        super(props);
     
        this.state = { 
            faultOwner :  this.props.location.state.faultReport.faultOwner,
            faultOwnerName :  this.props.location.state.faultReport.faultOwnerName,
            assignedAdminName :  this.props.location.state.faultReport.assignedAdminName,
            assignedAdminUid :  this.props.location.state.faultReport.assignedAdminUid,
            isAssigned :  this.props.location.state.faultReport.isAssigned,
            faultCategory :  this.props.location.state.faultReport.faultCategory,
            faultOutlet :  this.props.location.state.faultReport.faultOutlet,
            faultDescription :  this.props.location.state.faultReport.faultDescription,
            faultStatus :  this.props.location.state.faultReport.faultStatus,
            faultUpdates :  this.props.location.state.faultReport.updates,
            dateSubmitted : this.props.location.state.faultReport.dateSubmitted,
            updates : '',
            isResolved : false,
            attachmentURL :  this.props.location.state.faultReport.attachmentURL,
            downloadURL: [],
        };
    }

    async componentDidMount() {
        const downloadURL = await this.props.firebase
          .fireStorage()
          .child(this.state.attachmentURL)
          .getDownloadURL();
    
        this.setState(oldState => ({
          downloadURL: [...oldState.downloadURL, downloadURL],
        }));
    }

    deleteReport = (faultOwner, faultCategory, faultDescription, faultOutlet) => {
        this.props.firebase.doDeleteReport(faultOwner, faultCategory, faultDescription, faultOutlet);
        //this.props.history.push(ROUTES.ADMIN_HOME);
        window.alert("Report deleted successfully. Please navigate to Home.");
    };

    assignReport = (faultOwner, faultCategory, faultDescription, faultOutlet) => {
        this.props.firebase.doAssignSelectedFaultReport(faultOwner, faultCategory, faultDescription, faultOutlet);
        this.props.history.push(ROUTES.ADMIN_HOME);
    };

    updateSelectedFaultReport = (updates, faultOwner, faultCategory, faultDescription, faultOutlet) => {
        this.props.firebase.doUpdateSelectedFaultReportByAdmin(this.state.isResolved, updates, faultOwner, faultCategory, faultDescription, faultOutlet);
        this.setState({ updates : '', isResolved : false });
        //this.props.history.push(ROUTES.ADMIN_HOME);
        window.alert("Reported fault is updated successfully!");
    };l

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
     
    onChangeCheckbox = event => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    async componentDidMount() {
        const downloadURL = await this.props.firebase
          .fireStorage()
          .child(this.state.attachmentURL)
          .getDownloadURL();
    
        this.setState(oldState => ({
          downloadURL: [...oldState.downloadURL, downloadURL],
        }));
    }

    handleUploadSuccess = async filename => {
        const downloadURL = await this.props.firebase
          .fireStorage()
          .child(filename)
          .getDownloadURL();
    
        this.setState(oldState => ({
          filenames: [...oldState.filenames, filename],
          downloadURLs: [...oldState.downloadURLs, downloadURL],
          uploadProgress: 100,
          isUploading: false
        }));
      };

    render() {
        const faultOwner = this.state.faultOwner;
        const faultOwnerName = this.state.faultOwnerName;
        const assignedAdminName = this.state.assignedAdminName;
        const assignedAdminUid = this.state.assignedAdminUid;
        const isAssigned = this.state.isAssigned;
        const faultCategory = this.state.faultCategory;
        const faultOutlet = this.state.faultOutlet;
        const faultDescription = this.state.faultDescription;
        const faultStatus = this.state.faultStatus;
        const faultUpdates = this.state.faultUpdates;
        const dateSubmitted = this.state.dateSubmitted;
        const filenames = this.state.filenames;
        const downloadURL = this.state.downloadURL;

        var { updates, isResolved } = this.state;
        const isInvalidUpdate = updates === '';

        return (
        <AuthUserContext.Consumer>
        {authUser => (
        <Container>
            <hr />
                <div class="ui inverted fluid segment">
                <h1>{faultCategory} report by {faultOwnerName}</h1>
                </div>
            <p></p>

            <Segment>
            <div class="customFontBlack">
                <p>Reported by Store Associate Username: { faultOwnerName }</p>
                <p>Fault Category: { faultCategory }</p>
                <p>Fault Outlet: { faultOutlet }</p>
                <p>Fault Description: { faultDescription }</p>
                <p>Assigned Admin Name: { isAssigned ? assignedAdminName : <span>(nil)</span> }</p>
                <p>Date Submitted: {dateSubmitted}</p>
                <div>
                    <p>Image(s): </p>
                    {this.state.downloadURL.map((downloadURL, i) => {
                    return <img key={i} src={downloadURL} />;
                    })}
                    <hr/>
                </div>
            </div>
            <Message>Updates From Admin : { faultUpdates }</Message>
            <p></p>
            {
                assignedAdminUid === authUser.uid && (
                <Form size="small">
                <Form.Input
                fluid
                icon="edit"
                iconPosition="left"
                name="updates"
                value={updates}
                onChange={this.onChange}
                type="text"
                placeholder="Actions taken"
                />
                <p></p>
                <Button disabled={isInvalidUpdate || faultStatus === 'RESOLVED'} floated='right' color="orange" size="small" type="click" onClick={()=>{this.updateSelectedFaultReport(this.state.updates,
                faultOwner, 
                faultCategory, 
                faultDescription, 
                faultOutlet);}}>Update Case</Button>
                <Button disabled={true} floated='right' positive size="small">Assigned to Me</Button>
                {faultStatus === 'RESOLVED' && (
                <Button floated='right' negative size="small" onClick={()=>{this.deleteReport(
                faultOwner, 
                faultCategory, 
                faultDescription, 
                faultOutlet);}}>Delete Report</Button>
                )}
                <label class="customFontBlack">
                Mark as Resolved:
                <input
                    name="isResolved"
                    type="checkbox"
                    checked={isResolved}
                    onChange={this.onChangeCheckbox}
                />
                </label>
                <p></p>
                </Form>
                
            )}
            </Segment>
            {!isAssigned && (
                <Button floated='right' positive size="small" type="click" onClick={()=>{this.assignReport( 
                faultOwner, 
                faultCategory, 
                faultDescription, 
                faultOutlet);}}>Assign Case</Button>
                
            )}
            {isAssigned 
            && assignedAdminUid !== authUser.uid && (
                <Button disabled={true} floated='right' positive size="small" >Case taken by other Admin</Button>
            )}
            <p></p>
        </Container>
        )}
        </AuthUserContext.Consumer>
        );
    }
}

const condition = authUser => authUser && !!authUser.roles[ROLES.ADMIN];
 
export default compose(
  withAuthorization(condition),
  withFirebase,
)(ReportDetails);